<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">Periodical</span>
      <span class="spacer" />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="row">
        <div class="col-4">
          <txt label="Nature of Book Purchased" name="book_nature" v-model="model.book_nature" />
        </div>
        <div class="col-4">
          <txt label="Name of Publisher" name="publisher_name" v-model="model.publisher_name" />
        </div>
        <div class="col-4">
          <txt label="Name of Book" name="book_name" v-model="model.book_name" />
        </div>
      </div>
      <div class="row margin-t-m">
        <div class="col-4">
          <div class="label">
            <span class="input-label">Bill Date</span>
            <date-picker
              name="bill_date"
              :value="model.bill_date"
              @datevalue="(val)=> model.bill_date = val"
            />
          </div>
        </div>
        <div class="col-4">
          <txt label="Bill Number " name="bill_number" v-model="model.bill_number" />
        </div>
        <div class="col-4">
          <txt label="Bill Amount " type="number" name="bill_amount" v-model="model.amount" />
        </div>
      </div>
      <div class="row margin-t-m">
        <div class="col-12 margin-t-m">
          <div class="upload-heading">Upload the bill</div>
          <upload @change="(val)=>model.bill_url=val.data.location" />
        </div>
        <div class="col-12 margin-t-m">
          <btn text="Add Bill" type="secondary" @click="addMoreBooks()" />
        </div>
      </div>

      <div class="margin-t-l">
        <data-table
          :columns="tableColumns"
          :tableData="billList"
          :showinrow="true"
          :showhistory="false"
          :showedit="false"
          @delete="deleteItem($event)"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key == 'bill_number'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'bill_date'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'nature'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'publisher'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'book_name'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'amount'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'proofs'"
              >{{slotprops.value.record[slotprops.value.column.key].length}} attacment</p>
            </div>
          </template>
        </data-table>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Dependent added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showSuccessMsg: false,
      errmsg: "",
      toast: false,
      model: {
        book_nature: "",
        publisher_name: "",
        book_name: "",
        bill_number: "",
        bill_date: "",
        amount: 0,
        bill_url: ""
      },
      tableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Bill Number",
          key: "bill_number"
        },
        {
          label: "Bill Date",
          key: "bill_date"
        },
        {
          label: "Nature of Book Purchased",
          key: "book_nature"
        },
        {
          label: "Name of Publisher",
          key: "publisher_name"
        },
        {
          label: "Name of Book",
          key: "book_name"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
      billList: []
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      bpData: state => state.BP
    })
  },
  activated() {
    this.showSuccessMsg = false;
    this.setBPData();
  },
  methods: {
    ...mapActions({
      saveBPData: "dashboard/organisation/utilities/itdeclarations/saveBP"
    }),
    back() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        await this.savePDData({
          id: this.$route.query.id,
          data: this.billList,
          proofs: this.billList.map(item => {
            return item.proofs[0];
          })
        });
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setBPData() {
      try {
        if (this.bpData[this.$route.query.id]) {
          this.billList = this.bpData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreBooks() {
      try {
        this.billList.push({
          book_nature: this.model.book_nature,
          publisher_name: this.model.publisher_name,
          book_name: this.model.book_name,
          bill_number: this.model.bill_number,
          bill_date: this.model.bill_date,
          amount: this.model.amount,
          proofs: [this.model.bill_url]
        });
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    resetForm() {
      try {
        this.model = {
          book_nature: "",
          publisher_name: "",
          book_name: "",
          bill_number: "",
          bill_date: "",
          amount: 0,
          bill_url: ""
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteItem(record) {
      try {
        let index = this.billList.findIndex(item => item.name == record.name);
        this.billList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
.upload-heading {
  font-size: 13px;
  font-weight: 500;
}
</style>
